<template>
    <div>
        <!-- New page load skeleton -->
        <template v-if="spinner.get_job">
            <div class="af-jobview-inner-container afu-flex afu-flex-wrap afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto sm:afu-px-4 afu-items-start">
                <!-- jobview -->
                <div class="af-jobview-content afu-w-full afu-px-0 md:afu-pr-16 md:afu-w-70p afu-box-border afu-py-0 md:afu-py-12">
                    <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                        <div class="afu-bg-gray-500 afu-w-full afu-animate-pulse afu-h-8 afu-mb-6 afu-rounded-2xl" />
                        <div 
                            class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl"
                            v-for="n in 6"
                            :key="n"
                        />
                    </div>
                    <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                        <div 
                            class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl"
                            v-for="n in 16"
                            :key="n"
                        />
                    </div>
                </div>
                <div class="af-jobview-sidebar afu-w-30p afu-box-border afu-py-12 afu-sticky afu-top-80">
                    <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                        <div class="afu-bg-gray-500 afu-w-full afu-animate-pulse afu-h-10 afu-mb-6 afu-rounded-2xl" />
                        <div 
                            class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-6 afu-mb-4 afu-rounded-2xl"
                            v-for="n in 3"
                            :key="`first-${n}`"
                        />
                        <div 
                            class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-8 afu-mt-3 afu-mb-3 afu-rounded-2xl"
                            v-for="n in 2"
                            :key="`second-${n}`"
                        />
                    </div>
                </div>
            </div>
            <!-- full width -->
            <div 
                class="af-jobview-container af-jobview-skeleton afu-py-0 md:afu-pt-sliderWrapper--top md:afu-pb-sliderWrapper--bottom afu-overflow-hidden afu-mt-3 md:afu-mt-15 md:afu-mb-0 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light"
            >
                <div class="af-jobview-inner-container afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto">
                    <div class="af-jobview-sidebar-header afu-my-9 md:afu-my-4 afu-mb-3 afu-text-lg afu-text-center afu-font-bold afu-text-gray-600 afu-flex afu-justify-between afu-px-4 md:afu-px-0">
                        <div class="afu-bg-gray-500 afu-w-40 afu-animate-pulse afu-h-6 afu-mb-4 afu-rounded-2xl" />
                        <div>
                            <!--  -->
                        </div>
                    </div>
                </div>
                <div
                    class="af-similar-jobs afu-mt-10 afu-mb-4 swiper-container-horizontal afu-max-w-screen-xl afu-ml-auto afu-mr-auto"
                    id="af-similar-jobs"
                >
                    <div class="swiper-wrapper">
                        <div
                            v-for="job in 3"
                            :key="job"
                            class="af-similar-job-item afu-p-6 afu-mb-4 afu-rounded-card afu-bg-white swiper-slide afu-shadow-lg afu-flex afu-flex-col afu-relative"
                        >
                            <div class="afu-bg-gray-500 afu-w-20 afu-animate-pulse afu-h-4 afu-mb-4 afu-rounded-2xl" />
                            <div 
                                class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl"
                                v-for="n in 5"
                                :key="`${job}-${n}`"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <JobViewTemplate v-else />
    </div>
</template>

<script>
    import JobViewTemplate from '@/apps/jobview/001/components/JobViewTemplate';
    // import C1Spinner from '@/components/C1Components/C1Spinner';
    import JobViewMixin from '@/apps/jobview/mixins/JobViewMixin';

    export default {
        name: 'JobView',

        components: {
            JobViewTemplate,
            // C1Spinner,
        },

        mixins: [JobViewMixin],
    };
</script>

<style lang="scss">
    @media print {
        .af-jobview-content {
            background-color: #fff;
            font-size: 14px;
            height: 100%;
            left: 0;
            line-height: 18px;
            margin: 0;
            padding: 15px;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 9999;
        }
    }
</style>
